import React, { useContext, useState, useEffect } from 'react'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { billingFlowType, billing_period_options } from '../../../Constants'
import { awaitWithLoading } from '../../../services/utils'
import { reportGTM } from '../../Core/Utilities/GTagManger'
import PlanCard from './PlanCard'
import EstimatedMilesCard from './EstimatedMilesCard'
import StartDate from './StartDate'
import Billing from './Billing'
import CoverageCard from './CoverageCard'
import TotalCard from './TotalCard'
import coveragesApi from '../../../api/coverages.api'
import { SignRequiredPopup } from '../../PopUps/SignRequiredPopup.js'
import { calcToalAmountBaseOnEstimatedMileage, getOfferCoverages } from './utils'
import DataLayerService from '../../../services/DataLayerService'
import SessionContext, { SessionContextStore } from '../../../context/SessionContext'
import vehiclesApi from '../../../api/vehicles.api'
import AnalyticsApi from '../../../api/analytics.api'
import { CustomErrorPopup } from '../../PopUps/CustomErrorPopup'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { getCookie } from '../../../utilities/cookies'

export default () => {
  let location = useLocation()
  const offersContext = useContext(BuyingInsuranceContextStore)
  const { user } = useContext(SessionContextStore)
  const [offer, setOffer] = useState({})
  const [pdfs, setPdfs] = React.useState([])
  const { OfferId } = queryString.parse(location.search)

  const [popUpErrorState, setPopUpErrorState] = React.useState({
    title: '',
    body: '',
    showPopUp: false,
  })
  const cancelErrorPopup = () => setPopUpErrorState({ open: false, title: '', body: '' })

  const selectPlan = (plan, index) => {
    if (Object.values(plan.vehicleCoveragePrices).some(v => v.haslLienholder) && index === 0) {
      return
    }
    offersContext.choosePlan(plan)
    reportGTM('', '', {
      event: 'Coverage-plan-selected',
      plan: plan.name,
      price: plan.price,
      perMileCharge: plan.perMileCharge,
      fixedPrice: plan.fixedPrice,
    })
    offersContext.dispatch({ type: 'SELECT_PLAN', data: index })
    EventEmitterService.dispatch(EventKey.FLOW_COVERAGE_PLAN_PICKED)
  }

  const saveEstimatedMileage = async vehicles => {
    vehicles.forEach(async motorcycle => {
      const vehicleRes = await vehiclesApi.updateVehicle(motorcycle)
      if (!vehicleRes.ok) {
        EventEmitterService.dispatch(EventKey.ShowError, vehicleRes)
      }
    })
  }
  const onContinue = async () => {
    offersContext.passSummary(true)
    if (offersContext.subscriptionStartTime.getDate() < new Date().getDate()) {
      return
    }
    saveEstimatedMileage(user.userVehicles)
    await awaitWithLoading(offersContext.updateCoverages())
    await awaitWithLoading(offersContext.updateQuoteData())

    reportGTM('', '', { event: 'Continue-button-at-summary' })
    //always create context so bind can validate nothing is missing
    let res = await awaitWithLoading(
      coveragesApi.createDigitalSignatureDocs(offersContext.offerId, offersContext.offerCardWarnings.violationsId)
    )
    if (offersContext.offerCardWarnings?.violationsId.length > 0) {
      if (res.ok) {
        // TODO: handle case of error
        setPdfs(res.data)
        EventEmitterService.dispatch(EventKey.SIGN_REQUIERED_POPUP)
      }
    } else {
      if (Object.keys(offersContext.offerCardErrors).length > 0) return
      const eventText = billing_period_options[offersContext.billingPeriod].gtm
      reportGTM('', '', { event: eventText })
      EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
    }
  }

  const onSignComplete = async signForm => {
    if (offersContext.userSignatureRequiredForBrokerPurchase()) {
      EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
      const res = await awaitWithLoading(coveragesApi.sendDigitalSignatureSigningForm())
      return
    }

    const signature = signForm['signature']
    await awaitWithLoading(coveragesApi.saveDigitalSignature(signature))

    if (Object.keys(offersContext.offerCardErrors).length > 0) return
    EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
    offersContext.dispatch({ type: 'SAVE_SIGNATURE', data: signature })
  }

  const getCoverages = offer => {
    const res = getOfferCoverages(offer.vehicleCoveragePrices, offer.vehiclesDetailsForUi, offer.addOnCoveragePrices)
    setOffer(res)
  }

  useEffect(() => {
    if (offersContext.pricebreakdown && Object.keys(offersContext.pricebreakdown).length > 0 && !offersContext.pricebreakdown.code) {
      getCoverages(offersContext.pricebreakdown)
    }
  }, [offersContext.pricebreakdown])

  useEffect(() => {
    if (offersContext.plans.items.length === 0 && offersContext.plans.status === 'idle') {
      offersContext.loadPlans()
    }
  }, [offersContext.plans])

  useEffect(() => {
    const { items, status, selectedPlan } = offersContext.plans
    // select the first plan after plans are loaded
    if (status === 'idle' && items.length > 0 && selectedPlan === null && offersContext.options && !offersContext.isCustomizedCart) {
      // send marketing analytics
      AnalyticsApi.addUtmLog('quote', getCookie('page_full_url'))
      //
      if (user.userVehicles.some(vehicle => vehicle.lienholder === 'yes')) {
        selectPlan(items[1], 1)
      } else {
        selectPlan(items[0], 0)
      }
    }
  }, [offersContext.plans.status])

  useEffect(() => {
    // 🤮
    const zendeskIFrame = document.querySelector('[title="Button to launch messaging window"]')
    if (zendeskIFrame) zendeskIFrame.style = `display: none;`
  })

  const onDownloadPDF = async () => {
    if (Object.keys(offersContext.offerCardErrors).length > 0) {
      setPopUpErrorState({
        title: 'Invalid Quote',
        body: 'Please correct invalid fields before downloading your quote. Thank you.',
        showPopUp: true,
      })
      return
    }
    const event = { event: 'download-quote/summary-page' }
    DataLayerService.pushToDataLayer(event)

    const { data } = await awaitWithLoading(coveragesApi.getQuotePDF(offersContext.offerId))
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(data)
    link.download = 'your_quote.pdf'
    link.click()
    link.remove()
  }

  useEffect(() => {
    if (OfferId != undefined && offersContext.plans && offersContext.plans.items.length > 0) {
      offersContext.getOfferById(OfferId, '/insurance/summary')
    }
  }, [OfferId, offersContext.plans])

  return (
    <div className="plan-summary-page">
      {/* <header></header> */}
      <main>
        <div className="flex justify-evenly align-center" style={{ marginBottom: '1rem', minHeight: '7.625rem' }}>
          {offersContext.plans.items.length === 0 ? (
            <>
              <div className="plan-card"></div>
              <div className="plan-card"></div>
              <div className="plan-card"></div>
            </>
          ) : (
            offersContext.plans.items.map((plan, index) => (
              <PlanCard
                key={index}
                disabled={Object.values(plan.vehicleCoveragePrices).some(v => v.haslLienholder) && index === 0}
                {...plan}
                selected={offersContext.plans.selectedPlan === index && !offersContext.isCustomizedCart}
                setSelected={() => selectPlan(plan, index)}
              />
            ))
          )}
        </div>
        {/* vehicle milage */}
        {Object.keys(offersContext.pricebreakdown).length > 0 &&
          Object.keys(offersContext.options).length > 0 &&
          offersContext.plans.selectedPlan !== null && (
            <div style={{ padding: '0 0.5rem' }}>
              <EstimatedMilesCard />
            </div>
          )}
        {/* customized plan banner  */}
        {offersContext.isCustomizedCart && <div className="customized-plan">Your customized plan</div>}
        {/* coverage card */}
        {Object.keys(offer).length > 0 && Object.keys(offersContext.options).length > 0 ? (
          <CoverageCard offer={offer} options={offersContext.options} />
        ) : (
          <div className="coverage-card"></div>
        )}
        <StartDate />
        <Billing />
      </main>
      <SignRequiredPopup onSignComplete={onSignComplete} pdfs={pdfs} />
      <CustomErrorPopup
        title={popUpErrorState.title}
        body={popUpErrorState.body}
        open={popUpErrorState.showPopUp}
        onCancel={cancelErrorPopup}
      />
      <footer>
        {offersContext.pricebreakdown &&
          offersContext.pricebreakdown.totalAmount &&
          offersContext.vehiclesDetailes &&
          offersContext.billingFlowType !== '' &&
          offersContext.billingPeriod && (
            <TotalCard
              vehiclesDetailes={offersContext.vehiclesDetailes}
              pricebreakdown={offersContext.pricebreakdown}
              billingPeriod={offersContext.billingPeriod}
              billingFlowType={offersContext.billingFlowType}
            />
          )}
        <div>
          <div style={{ padding: '1rem .5rem', borderTop: 'solid 1px #e5dfd8' }}>
            <button className="save-btn" onClick={onContinue}>
              Save & continue
            </button>
          </div>
          <div
            style={{ fontSize: '12px', textAlign: 'center', textDecoration: 'underline', justifyContent: 'center', display: 'flex' }}
            onClick={onDownloadPDF}
          >
            <svg width="16" height="15" viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
              <g stroke="#5D00FF" strokeWidth="1.2" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 8.526v4.106c0 .755-.627 1.368-1.4 1.368H2.4c-.773 0-1.4-.613-1.4-1.368V8.526" />
                <path d="M11.5 7.158 8 10.578l-3.5-3.42M8 10.579V1" />
              </g>
            </svg>

            <div style={{ marginLeft: '0.5rem', color: 'var(--purple)', marginBottom: '1rem' }}>Download quote</div>
          </div>
        </div>
      </footer>
      <div id="tooltips"></div>
    </div>
  )
}
